<template>
    <div class="progress-container">
        <div class="row justify-content-center">
            <div class="col col-md-3">
                <div class="progress-bar--wrap">
                    <div class="progress">
                        <div class="progress-bar" :style="{width : progress}"></div>
                    </div>
                </div>
            </div>
            <div class="col col-md-2">
                <span class="paragraph--medium">{{completedQuestion}} of {{totalQuestions}} </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Progress",
        props: [
            'preGate'
        ],
        data() {
            return {
                totalQuestions: 13
            }
        },
        computed: {
            progress() {
                return (((this.completedQuestion) * 100) / this.totalQuestions) + '%';
            },
            completedQuestion() {
                if (typeof this.$store.state.current == 'number') {
                    return this.$store.state.current;
                } else if (typeof this.preGate !== 'undefined') {
                    return this.preGate;
                } else {
                    return null;
                }
            }
        }
    }
</script>

<style lang="stylus">
    .progress-container
        margin-bottom 4rem

    .progress-bar--wrap
        height: 2.4rem
        padding-top: 1.3rem
        margin-right: -1.5rem

        .progress
            height: 0.4rem
            border-radius 0
            background-color $color-grey-border

            .progress-bar
                border-radius 0
                background-color $color-blue-petrol
</style>